import React from 'react';

import MarketPlaceMenu from './marketplace-menu';
import OrderPlacedMenu from './order-placed-menu';
import TagMenu from './tag-menu';
import { EDITOR_TYPE_TAG, EDITOR_TYPE_ORDER_PLACED, EDITOR_TYPE_MARKETPLACE } from '../../rule-helper';
import '../../prop-types/allocation-rule.types';

/**
 * @param {object} props
 * @param {AllocationRuleType} props.rule
 * @returns {JSX.Element}
 * @class
 */
const SingleSelectionEditor = ({ rule }) => {
  const selectionControlMap = {
    [EDITOR_TYPE_TAG]: <TagMenu filterId={rule.filterId} />,
    [EDITOR_TYPE_ORDER_PLACED]: <OrderPlacedMenu filterId={rule.filterId} />,
    [EDITOR_TYPE_MARKETPLACE]: <MarketPlaceMenu filterId={rule.filterId} />,
  };

  return <div>{selectionControlMap[rule.editorType]}</div>;
};

export default SingleSelectionEditor;
